import React from 'react';
import { usePermissions } from 'react-admin';
import { useFetchLiquidityPositions } from '~/hooks/bankAccounts';
import { SelectInput } from '~/components';
import Skeleton from '@material-ui/lab/Skeleton';
import { FORM_CONTROL_WIDTH } from '~/hooks/useListFilterStyles';

interface BankAccountSelectProps {
  value: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  name?: string;
  source?: string;
  className?: string;
  emptyText?: string;
  disableHelperText?: boolean;
  allowEmpty?: boolean;
}

const BankAccountSelect: React.FC<BankAccountSelectProps> = ({
  value,
  onChange,
  label,
  name,
  source,
  className,
  emptyText,
  disableHelperText,
  allowEmpty,
}) => {
  const { permissions } = usePermissions();
  const hasPermissions = permissions?.includes('virtualLiquidityPosition.view');
  const { data, isFetching } = useFetchLiquidityPositions(hasPermissions);

  if (!hasPermissions) return null;
  if (isFetching) {
    return <Skeleton variant='rect' width={FORM_CONTROL_WIDTH} height={45} />;
  }

  const options =
    data?.data?.map((item: any) => ({
      value: item.id,
      text: `${item?.alias} (${item?.currency})`,
    })) ?? [];

  return (
    <SelectInput
      options={options}
      name={name}
      source={source}
      label={label}
      value={value}
      emptyText={emptyText}
      onChange={onChange}
      className={className}
      disableHelperText={disableHelperText}
      allowEmpty={allowEmpty}
    />
  );
};

export default BankAccountSelect;
